export const MIN_SEARCH_KEYWORD_LENGTH = 3;
export const SEARCH_DEBOUNCE_TIME = 300;

export const InputWithSuggestionsQueryKey = {
    LOAD_SUGGESTIONS: 'load-suggestions',
};
